import { render } from "./CloseIcon.vue?vue&type=template&id=16acf7b5&scoped=true"
import script from "./CloseIcon.vue?vue&type=script&lang=js"
export * from "./CloseIcon.vue?vue&type=script&lang=js"

import "./CloseIcon.vue?vue&type=style&index=0&id=16acf7b5&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-16acf7b5"

export default script